/**
 * Official UN SDG colors mapped to tag labels used on the ESG page.
 * Tinted backgrounds (~14% opacity) keep the official SDG hue for the swatch/border,
 * but several official hues (e.g. the SDG 7 yellow) are too light to use as text on
 * that tint — SDG_TAG_TEXT_COLORS are darkened variants of the same hue, each
 * verified to hit >=4.5:1 contrast against both the tint and a white card background.
 */
export const SDG_TAG_COLORS = {
  'Zero Hunger': '#DDA63A',
  'Good Health & Wellbeing': '#4C9F38',
  'Quality Education': '#C5192D',
  'Affordable & Clean Energy': '#FCC30B',
  'Decent Work': '#A21942',
  'Decent Work & Economic Growth': '#A21942',
  'Industry & Innovation': '#FD6925',
  'Reduced Inequality': '#DD1367',
  'Responsible Consumption': '#BF8B2E',
  'Climate Action': '#3F7E44',
};

export const SDG_TAG_TEXT_COLORS = {
  'Zero Hunger': '#8B6824',
  'Good Health & Wellbeing': '#3A792A',
  'Quality Education': '#C5192D',
  'Affordable & Clean Energy': '#8C6C06',
  'Decent Work': '#A21942',
  'Decent Work & Economic Growth': '#A21942',
  'Industry & Innovation': '#B34A1A',
  'Reduced Inequality': '#C6115C',
  'Responsible Consumption': '#8B6521',
  'Climate Action': '#3B753F',
};

export const getSdgTagStyle = (tag) => {
  const color = SDG_TAG_COLORS[tag] || '#6B7280';
  const textColor = SDG_TAG_TEXT_COLORS[tag] || '#374151';
  return {
    backgroundColor: `${color}24`,
    color: textColor,
    borderColor: `${color}40`,
  };
};

export const SDG_TILES = [
  { number: 2, src: '/images/sdg/sdg-02.png', alt: 'SDG 2: Zero Hunger' },
  { number: 3, src: '/images/sdg/sdg-03.png', alt: 'SDG 3: Good Health and Well-being' },
  { number: 4, src: '/images/sdg/sdg-04.png', alt: 'SDG 4: Quality Education' },
  { number: 7, src: '/images/sdg/sdg-07.png', alt: 'SDG 7: Affordable and Clean Energy' },
  { number: 8, src: '/images/sdg/sdg-08.png', alt: 'SDG 8: Decent Work and Economic Growth' },
  { number: 9, src: '/images/sdg/sdg-09.png', alt: 'SDG 9: Industry, Innovation and Infrastructure' },
  { number: 10, src: '/images/sdg/sdg-10.png', alt: 'SDG 10: Reduced Inequalities' },
  { number: 12, src: '/images/sdg/sdg-12.png', alt: 'SDG 12: Responsible Consumption and Production' },
  { number: 13, src: '/images/sdg/sdg-13.png', alt: 'SDG 13: Climate Action' },
  { number: 17, src: '/images/sdg/sdg-17.png', alt: 'SDG 17: Partnerships for the Goals' },
];
